import { useEffect, useState } from 'react';
import { isBrowser } from '../utils/dom.js';
import { useDebounceCallback } from './use-debounce.js';

export type WindowSize =
  | undefined
  | {
      width: number;
      height: number;
    };

export function useWindowSize(): WindowSize | undefined {
  function getSize(): WindowSize {
    if (!isBrowser) {
      return undefined;
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  const [windowSize, setWindowSize] = useState(getSize);

  const handleResize = useDebounceCallback(() => {
    setWindowSize(getSize());
  });

  useEffect(() => {
    if (!isBrowser) {
      return undefined;
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

  return windowSize;
}
